import { render, staticRenderFns } from "./BackgroundMusic.vue?vue&type=template&id=5c8cfa32&scoped=true&"
import script from "./BackgroundMusic.vue?vue&type=script&lang=js&"
export * from "./BackgroundMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cfa32",
  null
  
)

export default component.exports